



























































// tslint:disable:max-line-length
import { Component, Vue } from 'vue-property-decorator';
import AdultChart from './components/AdultChart.vue';
import Tooth from './components/Tooth.vue';
import InterdentalSpace from './components/InterdentalSpace.vue';
import { ApproximalPlaqueIndex, BleedingIndex, Chart, InterdentalSpace as IInterdentalSpace, SulcusBleedingIndex } from './model/chart';
import './styles.scss';

interface DentalIndex {
    name: string;
    isDisplayed: boolean;
    bleedingIndex(): BleedingIndex;
}

@Component({
    components: { AdultChart, InterdentalSpace },
})
export default class App extends Vue {
    public $refs!: {
        chart: AdultChart,
    };

    private teeth: { [key: string]: Tooth } | null = null;
    private readonly chart = new Chart();
    private readonly interdentalSpacesProxy: Array<{space: IInterdentalSpace, sbi: boolean, api: boolean}> = [];
    private readonly indexes: DentalIndex[] = [];

    get interdentalSpaces() {
        return this.interdentalSpacesProxy.filter((s) => Chart.isValidInterdentalSpace(s.space));
    }

    public created() {
        this.interdentalSpacesProxy.push(...this.chart.interdentalSpaces.map((s) => {
            return {
                space: s,
                sbi: false,
                api: false,
            };
        }));

        this.indexes.push(
            {
                name: 'SBI',
                isDisplayed: true,
                bleedingIndex: () => new SulcusBleedingIndex(this.chart, this.interdentalSpaces.filter((s) => s.sbi).map((s) => s.space)),
            },

            {
                name: 'API',
                isDisplayed: true,
                bleedingIndex: () => new ApproximalPlaqueIndex(this.chart, this.interdentalSpaces.filter((s) => s.api).map((s) => s.space)),
            },
        );
    }

    public mounted() {
        this.$appInsights.trackPageView({});

        const teethByFdi: { [key: number]: Tooth } = {};
        (this.$refs.chart.$children as Tooth[]).forEach((t) => teethByFdi[t.tooth.fdi] = t);
        this.teeth = teethByFdi;
    }

    public getTooth(fdi: number) {
        return this.teeth![fdi];
    }

    private center(pos: IInterdentalSpace, sign: number) {
        // Vector representing the line segment between the centers
        const lhs = this.teeth![pos.left.fdi];
        const rhs = this.teeth![pos.right.fdi];

        const v = {
            x: rhs.centerX - lhs.centerX,
            y: rhs.centerY - lhs.centerY,
        };

        // Vector perpendicular to the above one
        const n = { x: sign * v.y, y: -sign * v.x };

        const nNorm = Math.sqrt(n.x * n.x + n.y * n.y);

        const mid = {
            x: (lhs.centerX + rhs.centerX) / 2,
            y: (lhs.centerY + rhs.centerY) / 2,
        };

        const maxWidth = Math.max(lhs.boundingBox.height, rhs.boundingBox.height);
        const length = (maxWidth / 2) * 1.6;

        return {
            x: mid.x + (n.x / nNorm) * length,
            y: mid.y + (n.y / nNorm) * length,
        };
    }
}
